import React, { useEffect, useState } from 'react';
const NAMES = ['Anna', 'Markus', 'Laura', 'Thomas', 'Julia', 'Stefan', 'Sabine', 'Michael', 'Nicole', 'Andreas', 'Katrin', 'Christian', 'Melanie', 'Sebastian', 'Franziska', 'Daniel'];
const CITIES = ['Bayern 🇩🇪', 'Nordrhein-Westfalen 🇩🇪', 'Niedersachsen 🇩🇪', 'Berlin 🇩🇪', 'Baden-Württemberg 🇩🇪', 'Hessen 🇩🇪', 'Sachsen 🇩🇪', 'Hamburg 🇩🇪', 'Rheinland-Pfalz 🇩🇪', 'Brandenburg 🇩🇪'];
const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
interface NotificationData {
  name: string;
  initial: string;
  city: string;
  timeAgo: number;
}
function generateRandomNotification(): NotificationData {
  const name = NAMES[Math.floor(Math.random() * NAMES.length)];
  const initial = LETTERS[Math.floor(Math.random() * LETTERS.length)];
  const city = CITIES[Math.floor(Math.random() * CITIES.length)];
  const timeAgo = Math.floor(Math.random() * 14) + 2;
  return {
    name,
    initial,
    city,
    timeAgo
  };
}
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [notification, setNotification] = useState<NotificationData | null>(null);
  useEffect(() => {
    if (isDismissed) return;
    let showTimeout: ReturnType<typeof setTimeout>;
    let hideTimeout: ReturnType<typeof setTimeout>;
    const cycleNotification = () => {
      setNotification(generateRandomNotification());
      setIsVisible(true);
      hideTimeout = setTimeout(() => {
        setIsVisible(false);
        const nextDelay = 45000 + Math.floor(Math.random() * 30000);
        showTimeout = setTimeout(cycleNotification, nextDelay);
      }, 4000);
    };
    const initialTimeout = setTimeout(cycleNotification, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, [isDismissed]);
  if (isDismissed || !notification) return null;
  return <div className={`fixed bottom-4 left-4 sm:bottom-6 sm:left-6 z-50 transition-all duration-500 ease-in-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-196">
      <div className="bg-bg-alt/95 backdrop-blur-md border border-border-light rounded-2xl shadow-lg p-4 max-w-[300px] sm:max-w-[320px] relative pr-8" data-id="element-197">
        <button onClick={() => setIsDismissed(true)} className="absolute top-3 right-3 text-text-sec hover:text-text-main transition-colors p-1" aria-label="Benachrichtigung schließen" data-id="element-198">
          ✕
        </button>

        <div className="flex items-center gap-3 mb-2" data-id="element-199">
          <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0" data-id="element-200">
            <span className="text-sm" data-id="element-201">⚽</span>
          </div>
          <span className="text-text-main text-sm font-bold" data-id="element-202">
            {notification.name} {notification.initial}.{' '}
            <span className="text-text-sec font-normal ml-1 text-xs" data-id="element-203">
              {notification.city}
            </span>
          </span>
        </div>

        <p className="text-text-main text-sm mb-2 font-medium" data-id="element-204">
          hat gekauft{' '}
          <span className="text-primary font-bold" data-id="element-205">SPORTUNTERRICHT FERTIG</span>
        </p>

        <div className="flex items-center gap-2 mt-2 pt-2 border-t border-border-light" data-id="element-206">
          <div className="w-2 h-2 bg-primary rounded-full" data-id="element-207"></div>
          <p className="text-text-sec text-[10px] font-bold uppercase tracking-wider" data-id="element-208">
            Verifizierter Kauf · vor {notification.timeAgo} Min.
          </p>
        </div>
      </div>
    </div>;
}